import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import { UiWrapper } from '@coinscrap/webapp-core';

UiWrapper.defineComponent('view', {
	styles: {
		default: {
			width: '100%',
			color: CONFIG.colors.black,
			boxSizing: 'border-box',
			fontFamily: CONFIG.fonts.regular,
		},

		relativeSt: {
			position: 'relative',
		},

		absoluteSt: {
			position: 'absolute',
		},

		// HEADER
		headerSt: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
			alignItems: 'center',
			position: 'fixed',
			width: isMobile ? '95%' : '100%',
			height: 64,
			top: 0,
			zIndex: 1,
			backgroundColor: 'white',
			borderBottom: '2px solid rgba(241, 212, 190, 0.4)',
			boxShadow: CONFIG.layout.header.showShadow
				? ' 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
				: undefined,
		},
		headerInnerSt: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			maxWidth: isMobile ? 'calc(100% - 20px)' : CONFIG.components.mainWrapper.width,
			height: '100%',
			zIndex: 2,
		},
		headerLogosSt: {
			backgroundColor: 'transparent',
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'flex-start',
			zIndex: 3,
			gap: isMobile ? '10px' : '15px',
			width: 'initial',
		},

		headerButtonsSt: {
			width: 'initial',
		},

		headerButtonsAgentSt: {
			display: 'flex',
			flexDirection: 'row',
			width: 'initial',
			marginLeft: 'auto',
		},

		// FOOTER
		footerSt: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: CONFIG.colors.primaryDark,
		},
		footerInnerSt: {
			display: 'flex',
			flexDirection: isMobile ? 'column' : 'row',
			justifyContent: isMobile ? 'center' : 'space-between',
			alignItems: 'center',
			maxWidth: isMobile ? 'calc(100% - 20px)' : CONFIG.components.mainWrapper.width,
			padding: isMobile ? '10px 0' : '0',
		},

		// INPUT ROWS
		//Double grid columns for web. One-and-one grid colum for mobile devices.
		inputRowSt: {
			display: 'grid',
			alignItems: 'flex-start',
			marginBottom: 8,
			gap: isMobile ? 50 : 20,
			gridTemplateColumns: isMobile
				? 'repeat(1, minmax(0, 1fr))'
				: 'repeat(3, minmax(0, 1fr))',
			rowGap: isMobile ? 5 : 25,
			width: 'initial',
		},
		//Input free columns.
		inputFreeRowSt: {
			display: 'flex',
			flexDirection: isMobile ? 'column' : 'row',
			justifyContent: 'flex-start',
			marginBottom: 0,
			gap: isMobile ? 5 : 20,
			width: '100%',
		},

		// WRAPPERS
		totalCenterSt: {
			height: '100%',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		innerWrapperSt: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			justifyContent: 'flex-start',
			flexGrow: 1,
			width: '100%',
		},
		loginAgentFormWrapperSt: {
			maxWidth: '350px',
		},

		// LOADING MODAL
		loadingModalSt: {
			display: 'flex',
			height: '100%',
			alignItems: 'center',
			justifyContent: 'center',
			backgroundColor: CONFIG.colors.loadingModalBackground,
		},

		//PCB and Health questionnaries
		questionnariesSt: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			marginTop: 10,
			width: '80%',
		},
		//PBC and Health wrapper
		wrapperQuestionnariesSt: {
			alignItems: 'center',
			display: 'flex',
			flexGrow: 1,
			justifyContent: 'space-between',
			width: '70%',
		},
		//PBC and Health text wrapper
		wrapperTextQuestionnariesSt: {
			flexDirection: 'row',
			justifyContent: 'flex-start',
		},
		//PBC and Health buttons wrapper
		wrapperButtonsQuestionnariesSt: {
			alignItems: 'center',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
			marginLeft: isMobile ? 5 : 30,
			width: 'initial',
		},

		//Bank Account's banner
		bannerBankAccountSt: {
			backgroundColor: CONFIG.colors.primaryLighter,
			fontFamily: CONFIG.fonts.semiBold,
			fontSize: 20,
			marginBottom: 10,
			marginTop: 20,
			padding: '30px 200px',
			width: '100%',
		},
		itemStepSt: {
			alignItems: 'center',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-start',
			marginBottom: 15,
			marginTop: 10,
			width: 'initial',
		},

		//Agent Dashboard
		dahboardFullCenterSt: {
			width: '100vw',
			position: 'relative',
			left: 'calc(-50vw + 50%)',
			// paddingLeft: 50,
			// paddingRight: 50,
		},
		agentTableRowSt: {
			display: 'grid',
			backgroundColor: CONFIG.colors.primaryLighter,
			gap: 20,
			gridTemplateColumns:
				'repeat(2, minmax(0, 1fr)) 175px 175px 150px 100px 100px minmax(0, 1fr)',
			marginBottom: 25,
			padding: '20px 50px',
			width: '100%',
		},
		isGlobalAgentTableRowSt: {
			display: 'grid',
			backgroundColor: CONFIG.colors.primaryLighter,
			gap: 20,
			gridTemplateColumns:
				'repeat(2, minmax(0, 1fr)) 175px 175px 150px minmax(0, .5fr) 100px minmax(0, 1fr)',
			marginBottom: 25,
			padding: '20px 50px',
			width: '100%',
		},

		//Wrapper for FollowUp view
		progressWrapperSt: {
			alignItems: 'stretch',
			display: 'flex',
			flexDirection: 'row',
			marginBottom: isMobile ? 10 : 0,
			marginTop: isMobile ? 40 : 40,
			width: 'initial',
		},
		progressTextWrapperSt: {
			alignItems: 'baseline',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-around',
			marginLeft: 30,
			width: 'initial',
		},

		//Progress bar for FollowUp view
		followUpSt: {
			backgroundColor: CONFIG.colors.white,
			borderRadius: 45,
			display: 'flex',
			flexDirection: 'column',
			height: 470,
			position: 'relative',
			width: 32,
		},
		//Dashboard follow up non-active dots
		dotsSt: {
			backgroundColor: CONFIG.colors.primary,
			borderRadius: '50%',
			height: 16,
			width: 16,
		},
		//Dashboard follow up active dots
		activeDotsSt: {
			backgroundColor: CONFIG.colors.white,
			borderRadius: '50%',
			height: 16,
			width: 16,
		},

		//Buttons wrapper modal agent notification
		notificationWrapperSt: {
			display: 'flex',
			flexDirection: isMobile ? 'column' : 'row',
			justifyContent: 'space-around',
			gap: 16,
			width: 'initial',
			marginTop: 30,
		},

		//Resume agent
		agentResumeWrapperSt: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-around',
			gap: 30,
			marginTop: 30,
			marginBottom: 30,
			width: 'initial',
			maxWidth: 1400,
		},
		agentResumeDoubleColumnWrapperSt: {
			width: '100%',
			display: 'grid',
			gridTemplateColumns: 'repeat(2, 1fr)',
			rowGap: 20,
			columnGap: 60,
			alignItems: 'initial',
		},

		// PAQUETES TABLE
		tableCoverageColumnSt: {
			width: 325,
			marginRight: 2,
		},

		tablePackColumnSt: {
			width: 200,
			marginRight: 2,
		},

		tableFirstCellSt: {
			backgroundColor: CONFIG.colors.white,
			height: 275, //355,
			marginBottom: 2,
		},

		tableFirstRowSt: {
			backgroundColor: CONFIG.colors.primaryLighter,
			//height: 275, //355,
			marginBottom: 2,
		},

		coverageCellSt: {
			backgroundColor: CONFIG.colors.primaryLighter,
			height: 100, //'130px',
			marginBottom: 2,
			padding: 20,
		},

		coverageHeadMobileSt: {
			backgroundColor: CONFIG.colors.primaryLighter,
			padding: '15px 10px',
		},

		coverageCellMobileSt: {
			backgroundColor: CONFIG.colors.primaryLighter,
			marginBottom: 2,
			padding: 20,
		},
		coverageMobileContentSt: {
			paddingTop: 10,
			marginTop: 10,
			borderTop: `1px solid ${CONFIG.colors.grey}`,
		},
		packHeaderCellSt: {
			backgroundColor: CONFIG.colors.primary,
			height: 50,
		},

		packCellSt: {
			backgroundColor: CONFIG.colors.primaryLighter,
			height: 100, //'130px',
			marginBottom: 2,
		},

		flewRowSt: {
			display: 'flex',
			flexDirection: 'row',
		},

		justifyContentCenterSt: {
			justifyContent: 'center',
		},

		justifyContentSpaceBetweenSt: {
			justifyContent: 'space-between',
		},

		justifyContentSpaceAroundSt: {
			justifyContent: 'space-around',
		},

		justifyContentFlexStartSt: {
			justifyContent: 'flex-start',
		},

		justifyContentFlexEndSt: {
			justifyContent: 'flex-end',
		},

		alignItemsCenterSt: {
			alignItems: 'center',
		},

		alignItemsFlexStartSt: {
			alignItems: 'flex-start',
		},

		alignItemsFlexEndSt: {
			alignItems: 'flex-end',
		},

		widthFitContentSt: {
			width: 'fit-content',
		},

		displayGridSt: {
			display: 'grid',
		},

		alignGridItemsStartSt: {
			alignItems: 'start',
		},

		gridCols1St: {
			gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
		},

		gridCols2St: {
			gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
		},

		gridCols3St: {
			gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
		},

		gridCols4St: {
			gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
		},

		gridCols5St: {
			gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
		},

		gridCols6St: {
			gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
		},

		colSpan1St: {
			gridColumn: 'span 1 / span 1',
		},

		colSpan2St: {
			gridColumn: 'span 2 / span 2',
		},

		colSpan3St: {
			gridColumn: 'span 3 / span 3',
		},

		gap1St: {
			gap: '0.25rem',
		},

		gap2St: {
			gap: '0.5rem',
		},

		gap3St: {
			gap: '0.75rem',
		},

		gap4St: {
			gap: '1rem',
		},

		...CONFIG.commonStyles.styles,
	},
});
